module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAbCAYAAACAyoQSAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADuSURBVHgB1ZXtDYIwEIbfdgJHqJvIBroBbqIb4ATESRyBEcoGusF5RUwMaYF+HIlPQqFtcm+fHz0UER0BtPzssA2V5sFsGOgwik1dYDeGS9MrpfaahxdPrtiGIUd9Z2xsIWs7WLoP/bN4hiyVd5VtHyRDGzwKbx5IBoM5qLxtgyWorK2lJUsB2xprcaejfGyovvYt8n3q+XVHHvENh0+64+dJaXRztXVoY2yPN6RxQiqJti1y4SIXisMgl0jbBqVYaWuLWE6C7UJojdK4onOWkILC7bGGFOT/GXSQxmNrIM3ENr8RRAQ39Lm7Bv/CG7A7oUxOFPVYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/decreasing-triangle-white.png
// module id = EnAl
// module chunks = 1